import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IMsalContext } from "@azure/msal-react";
import { WikiState } from "../Model";
import { RootState } from "..";
import { getWikis as getWikisApi } from "../../Api";

const initialState: WikiState = {
  selectedWikiName: null,
  selectedWiki: null,
  wikis: [],
  isLoaded: false
}

export const WikiSlice = createSlice({
  name: 'wiki',
  initialState: initialState,
  reducers: {
    setSelectedWiki: (state, action) => {
      if (action.payload) {
        state.selectedWiki = action.payload;
        state.selectedWikiName = state.selectedWiki?.name ?? null;
      }
    },
    setSelectedWikiName: (state, action) => {
      if (state.selectedWikiName !== action.payload) {
        state.selectedWikiName = action.payload;
        state.isLoaded = false;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWikis.fulfilled, (state, action) => {
        state.isLoaded = true;
        state.wikis = action.payload;

        if (state.selectedWikiName !== null) {
          state.selectedWiki = state.wikis.find(e => e.name === state.selectedWikiName) ?? null;
        }

        if (state.selectedWiki === null && state.wikis.length !== 0) {
          state.selectedWiki = state.wikis[0];
          state.selectedWikiName = state.selectedWiki.name;
        }
      })
  }
})
export const getWikis = createAsyncThunk(
  'wiki/getWikis',
  async (context: IMsalContext) => {
    return await getWikisApi(context);
  }
);
export const selectSelectedWikiName = (state: RootState) => state.wiki.selectedWikiName;
export const selectSelectedWiki = (state: RootState) => state.wiki.selectedWiki;
export const selectWikis = (state: RootState) => state.wiki.wikis;
export const selectIsLoaded = (state: RootState) => state.wiki.isLoaded;
export const { setSelectedWiki, setSelectedWikiName } = WikiSlice.actions;
export default WikiSlice.reducer;